import {Component, EventEmitter, Input, Output} from '@angular/core';
import {take} from 'rxjs';
import {CompetentAuthorityModel} from 'src/app/shared/models/competent-authority.model';
import {CompetentAuthoritiesRepository} from 'src/app/shared/states/competent-authorities.repository';
import {ContactModel} from '../../models/contact.model';
import {AuthorityContactService} from '../../Service/authority-contact.service';

@Component({
  selector: 'app-competent-authority-edit-dialog',
  standalone: false,
  templateUrl: './competent-authority-edit-dialog.component.html',
  styleUrls: ['./competent-authority-edit-dialog.component.scss']
})
export class CompetentAuthorityEditDialogComponent {

  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() authority: CompetentAuthorityModel = {
    name: '',
    animalShelter: {id: 0},
    id: 0,
    contacts: [{} as ContactModel]
  } as CompetentAuthorityModel;
  @Output() updated = new EventEmitter<CompetentAuthorityModel>();
  newContact: ContactModel | any = {} as ContactModel;
  validationStatusChanged: any;

  constructor(
    private readonly _repo: CompetentAuthoritiesRepository,
    private readonly _authorityContactService: AuthorityContactService
  ) {
  }

  ngOnChanges(): void {
    if (this.authority.contacts && this.authority.contacts.length > 0) {
      this.newContact = this.authority.contacts[0];
    } else {
      this.newContact = {id: 0} as ContactModel;
    }
  }

  update(): void {
    if (!this.newContact.id) {
      this.newContact.type = 'public-institution';
    }
    this._authorityContactService.saveContact(this.newContact).pipe(take(1)).subscribe({
      next: (savedContact) => {
        this.authority.contacts = savedContact?.id ? [{id: savedContact.id}] : [];
        this._updateAuthority();
      },
      error: (err) => {
        console.error('Fehler beim Speichern des Kontakts:', err);
      }
    });
  }

  private _updateAuthority(): void {
    this._repo.updateCompetentAuthority(this.authority.id, this.authority).pipe(take(1)).subscribe({
      next: (updatedAuthority) => {
        this.updated.emit(updatedAuthority);
        this.visibleChange.emit(false);
      },
      error: (err) => {
        console.error('Fehler beim Aktualisieren der CompetentAuthority:', err);
      }
    });
  }

  cancel(): void {
    this.visibleChange.emit(false);
  }

  onSetNewContact($event: any) {
    this.newContact = $event;
  }
}
